import React, { useState, useEffect, useRef } from "react";
import styles from "./Invoice.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { toCommas } from "../../utils/utils";
import { useSnackbar } from "react-simple-snackbar";
import AddSupplier from "../Suppliers/AddSupplier";
import IconButton from "@material-ui/core/IconButton";
import { registerAndSubscribe } from "../../registerAndSubscribe";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import { Container, Grid } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import { initialState } from "../../initialState";
import currencies from "../../currencies.json";
import {
  createInvoice,
  getInvoice,
  updateInvoice,
} from "../../actions/invoiceActions";
import SignaturePad from "./SignaturePad";
import { getClientsByUser, getAllClients } from "../../actions/clientActions";
import { getAllSuppliers } from "../../actions/supplierActions";
// import {getItems } from '../../actions/itemActions'
import AddClient from "./AddClient";
import InvoiceType from "./InvoiceType";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { getItemsByUser, getAllItems } from "../../actions/itemActions";
import { endOfDay } from "date-fns";
// import AddItem from '../Items/addItem'

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  table: {
    minWidth: 650,
  },

  headerContainer: {
    // display: 'flex'
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(1),
  },
}));

const Invoice = () => {
  const isMountedRef = useRef(true);
  const location = useLocation();
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [rates, setRates] = useState(0);
  const [vat, setVat] = useState(0);
  const [currency, setCurrency] = useState(currencies[0].value);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState("");
  const [client, setClient] = useState(null);
  const [signatureDataUrl, setSignatureDataUrl] = useState(null);
  //console.log(client);

  // (supplier);
  const [openSnackbar, closeSnackbar] = useSnackbar();
  // const [item, setItem] = useState(null);
  const [type, setType] = useState("Order");
  const [status, setStatus] = useState("");
  const { id } = useParams();
  const clients = useSelector((state) => state.clients.clients);
  const suppliers = useSelector((state) => state.suppliers.suppliers);

  const [supplier, setSupplier] = useState(null);
  // console.log("Supplier", supplier);
  const items = useSelector((state) => state.items.items);
  // console.log(items)
  const { invoice } = useSelector((state) => state.invoices);
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  
  // Filter clients for dealers - only show assigned clients
  const filteredClients = user?.result?.userType === "dealer" && user?.result?.selectedClients 
    ? clients.filter(client => user.result.selectedClients.some(assignedClient => {
        // Handle both cases: assignedClient as ObjectId string or as populated client object
        const assignedClientId = typeof assignedClient === 'string' ? assignedClient : assignedClient._id;
        return assignedClientId === client._id;
      }))
    : clients;

  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(
    today.getTime() + 7 * 24 * 60 * 60 * 1000
  );
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  useEffect(() => {
    getTotalCount();
    // eslint-disable-next-line
  }, []);

  const getTotalCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/invoices/count?searchQuery=${user?.result?._id}`,
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );
      if (!isMountedRef.current) {
        return;
      }
      const currentDate = new Date();
      // console.log("Date: ", currentDate);

      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");
      const randomID = Math.floor(100 + Math.random() * 900);
      const invoiceNumber = `${randomID}${seconds}`;
      // const invoiceNumber = `${year}${month}${day}${hours}${minutes}${seconds}`;

      // console.log("CurrentDate", currentDate);

      //   console.log(response.data);
      //Get total count of invoice from the server and increment by one to serialized numbering of invoice
      setInvoiceData({
        ...invoiceData,
        invoiceNumber: invoiceNumber,
      });
    } catch (error) {
      console.error(error);
    }
  };
  // Listen for changes in the form data
  useEffect(() => {
    // Whenever formData changes, set hasUnsavedChanges to true
    setHasUnsavedChanges(true);
  }, [invoiceData]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        // Display a confirmation message
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave this page?";
      }
    };

    // Attach the event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);
  useEffect(() => {
    dispatch(getInvoice(id));

    // eslint-disable-next-line
  }, [id]);
  useEffect(() => {
    const defaultSupplier = suppliers.filter(
      (sup) => sup.name === "Sadhana Ayurvedics Pvt. Ltd."
    );
    // console.log("Default Supplier", defaultSupplier);
    setSupplier(defaultSupplier[0]);
  }, [suppliers]);
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllClients()
    );
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllSuppliers()
    );

    dispatch(
      // getItemsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllItems()
    );
    // eslint-disable-next-line
  }, [dispatch]);
  useEffect(() => {
    if (!invoice) {
      setClient(null);
      setSupplier(null);
    }
  }, [location]);
  useEffect(() => {
    if (invoice) {
      //Automatically set the default invoice values as the ones in the invoice to be updated
      setInvoiceData(invoice);
      setRates(invoice.rates);
      setClient(invoice.client);
      setSupplier(invoice.supplier);
      setType(invoice.type);
      setStatus(invoice.status);
      setSelectedDate(invoice.dueDate);
      setSignatureDataUrl(invoice.signatureDataUrl);
    }
  }, [invoice]);

  useEffect(() => {
    if (type === "Receipt") {
      setStatus("Paid");
    } else {
      setStatus("Unpaid");
    }
  }, [type]);

  const defaultProps = {
    options: currencies,
    getOptionLabel: (option) => option.label,
  };

  const clientsProps = {
    options: filteredClients,
    getOptionLabel: (option) => option.name,
  };
  const suppliersProps = {
    options: suppliers,
    getOptionLabel: (option) => option.name || "",
  };
  const itemsProps = {
    options: items,
    getOptionLabel: (option) => option.itemName || "",
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleRates = (e) => {
    setRates(e.target.value);
    setInvoiceData((prevState) => ({ ...prevState, tax: e.target.value }));
  };

  // console.log(invoiceData)
  // Change handler for dynamically added input field
  const handleChange = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.value;
    setInvoiceData({ ...invoiceData, items: values });
  };
  // const handleNameChange = (index, e, value) => {
  //   console.log(value)
  //   const values = [...invoiceData.items];
  //   values[index].itemName = value;
  //   values[index].unitPrice = getItemPrice(value);
  //   setInvoiceData({ ...invoiceData, items: values });

  // };
  // const getItemPrice = (itemName) => {
  //   // console.log('getItemPrice function in', itemName);
  //   // console.log("itemName: " + itemName)

  //   const selectedItem = items.find((item) => item.itemName === itemName.itemName);
  //   // console.log("selected item: " + selectedItem)
  //   return selectedItem ? selectedItem.unitPrice : 0; // Return 0 if item price is not found
  // };
  const handleNameChange = (index, value) => {
    const updatedItems = [...invoiceData.items];
    updatedItems[index] = {
      ...updatedItems[index],
      itemName: value.itemName,
      unitPrice: value.unitPrice,
      weight: value.weight,
    };
    setInvoiceData({ ...invoiceData, items: updatedItems });
  };

  const getItemPrice = (itemName) => {
    const selectedItem = items.find((item) => item.itemName === itemName);
    return selectedItem ? selectedItem.unitPrice : 0;
  };
  const getItemWeight = (itemName) => {
    const selectedItem = items.find((item) => item.itemName === itemName);
    return selectedItem ? selectedItem.weight : 0;
  };

  useEffect(() => {
    //Get the subtotal
    const subTotal = () => {
      var arr = document.getElementsByName("amount");
      var subtotal = 0;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].value) {
          subtotal += +arr[i].value;
        }
        // document.getElementById("subtotal").value = subtotal;
        setSubTotal(subtotal);
      }
    };

    subTotal();
  }, [invoiceData]);

  useEffect(() => {
    const total = () => {
      //Tax rate is calculated as (input / 100 ) * subtotal + subtotal
      const overallSum = subTotal - (rates / 100) * subTotal;
      //VAT is calculated as tax rates /100 * subtotal
      setVat((rates / 100) * subTotal);
      setTotal(overallSum);
    };
    total();
  }, [invoiceData, rates, subTotal]);

  const handleAddField = (e) => {
    e.preventDefault();
    setInvoiceData((prevState) => ({
      ...prevState,
      items: [
        ...prevState.items,
        {
          itemName: "",
          unitPrice: "",
          quantity: "",
          discount: "",
          amount: "",
        },
      ],
    }));
  };

  const handleRemoveField = (index) => {
    const values = invoiceData.items;
    values.splice(index, 1);
    setInvoiceData((prevState) => ({ ...prevState, values }));
    // console.log(values)
  };
  const handleClient = (value) => {
    setSelectedDate(today.getTime() + value?.dueDate * 24 * 60 * 60 * 1000);
    // Ensure the client object preserves the _id field
    if (value && value._id) {
      setClient({
        ...value,
        _id: value._id
      });
    }
  }; // Auto-fill client for dealers when they have only one assigned client
  useEffect(() => {
    if (user?.result?.userType === "dealer" && 
        user?.result?.selectedClients && 
        user.result.selectedClients.length === 1 && 
        !client && 
        !invoice && 
        filteredClients.length > 0) {
      
      // Find the assigned client in the filtered clients
      const assignedClient = filteredClients.find(client => {
        const assignedClientId = typeof user.result.selectedClients[0] === 'string' 
          ? user.result.selectedClients[0] 
          : user.result.selectedClients[0]._id;
        return assignedClientId === client._id;
      });
      
      if (assignedClient) {
        setClient(assignedClient);
        handleClient(assignedClient);
      }
    }
  }, [user, filteredClients, client, invoice, handleClient]);

 
  // console.log(invoiceData);
  const handleSendNotification = async (userName, total) => {
    try {
      const notificationData = {
        userName: userName,
        total: total,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API}/send-notification`,
        notificationData
      );

      console.log("Notification sent:", response.data);
      // Handle success, update state, show a success message, etc.
    } catch (error) {
      console.error("Error sending notification:", error);
      // Handle error, show error message, etc.
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Client object being submitted:", client);
    const hasEmptyItems = invoiceData.items.some((item) => !item.quantity);
    // console.log(hasEmptyItems);
    if (hasEmptyItems) {
      openSnackbar("Please fill in all item quantities");
      return;
    }
    
    if (!total) {
      openSnackbar("Please add items to calculate total");
      return;
    }
    
    if (!client) {
      openSnackbar("Please select a party/client");
      return;
    }
    
    if (!supplier) {
      openSnackbar("Please select a supplier");
      return;
    }
    
    if (!signatureDataUrl) {
      openSnackbar("Please provide a signature");
      return;
    }
    // const currentDate = new Date();
    // const year = currentDate.getFullYear();
    // const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    // const day = String(currentDate.getDate()).padStart(2, "0");
    // const hours = String(currentDate.getHours()).padStart(2, "0");
    // const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    // const seconds = String(currentDate.getSeconds()).padStart(2, "0");
    // const randomID = Math.floor(100 + Math.random() * 900);
    //    const invoiceNumber = `${randomID}${seconds}`;

    // const invoiceNumber = `${year}${month}${day}${hours}${minutes}${seconds}`;

    setError("");
    if (invoice) {
      dispatch(
        updateInvoice(
          invoice._id,
          {
            ...invoiceData,
            subTotal: subTotal,
            total: total,
            vat: vat,
            rates: rates,
            currency: currency,
            dueDate: selectedDate,
            client,
            supplier,
            signatureDataUrl,
            type: type,
            status: status,
          },
          history
        )
      );

      history.push(`/invoice/${invoice._id}`);
    } else {
      dispatch(
        createInvoice(
          {
            ...invoiceData,
            subTotal: subTotal,
            total: total,
            vat: vat,
            rates: rates,
            currency: currency,
            dueDate: selectedDate,
            invoiceNumber: invoiceData.invoiceNumber,
            client,
            supplier,
            signatureDataUrl,
            type: type,
            status: status,
            paymentRecords: [],
            creator: [user?.result?._id || user?.result?.googleId],
            createdAt: new Date(),
          },
          history
        )
      );
    }
    console.log(user.result.name, total);
    try {
      await registerAndSubscribe(user.result.name, total);
    } catch (error) {
      console.error("Error:", error);
    }

    handleSendNotification(user.result.name, total);

    if (isMountedRef.current) {
      setInvoiceData(initialState);
    }
  };

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openSupplier, setOpenSupplier] = useState(false);
  const CustomPaper = (props) => {
    return <Paper elevation={3} {...props} />;
  };

  if (!user) {
    history.push("/login");
  }
  function matchAllWordsInAnyOrder(inputValue, clientName) {
    const inputWords = inputValue.split(" ").filter(Boolean);
    const clientWords = clientName.split(" ").filter(Boolean);

    // Check if all words in the input are present in the client name
    return inputWords.every((word) =>
      clientWords.some((clientWord) => clientWord.includes(word))
    );
  }
  function matchAllItemWordsInAnyOrder(inputValue, itemName, itemWeight) {
    const inputWords = inputValue.split(" ").filter(Boolean);
    const itemWords = [...itemName.split(" "), ...(itemWeight ? itemWeight.split(" ") : [])].filter(Boolean);

    // Check if all words in the input are present in the client name or weight
    return inputWords.every((word) =>
        itemWords.some((itemWord) => itemWord.includes(word))
    );
}

  return (
    <div className={styles.invoiceLayout}>
      <form onSubmit={handleSubmit} className="mu-form">
        <AddClient setOpen={setOpen} open={open} />
        <AddSupplier setOpen={setOpenSupplier} open={openSupplier} />
        <Container className={classes.headerContainer}>
          <Grid container justifyContent="space-between">
            <Grid item>
              {/* <Avatar alt="Logo" variant='square' src="" className={classes.large} /> */}
            </Grid>
            <Grid item>
              <InvoiceType type={type} setType={setType} />
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ marginRight: "10px", fontWeight: "bold" }}>
                  ID:
                </span>
                <div
                  style={{
                    backgroundColor: "#f4f4f4",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  <span style={{ color: "black" }}>
                    {invoiceData.invoiceNumber}
                  </span>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
        <Divider />
        <Grid
          container
          justifyContent="space-between"
          style={{ marginTop: "40px", marginBottom: "20px" }}
        >
          <Grid item xs={12} md={6} style={{ paddingRight: "10px" }}>
            <Container>
              <Typography
                variant="overline"
                style={{ color: "gray", paddingRight: "3px" }}
                gutterBottom
              >
                Order from
              </Typography>

              {client && (
                <>
                  <Typography variant="subtitle1" gutterBottom>
                    {client.name}
                  </Typography>

                  {/* <Typography variant="body2">{client.email}</Typography> */}
                  <Typography variant="body1">{client.phone}</Typography>
                  {/* <Typography variant="body2">{client.address}</Typography>
                  <Typography variant="body2">{client.dueDate}</Typography> */}
                  {/* <Typography variant="body2">
                      {client.dueDate} Credit Days
                    </Typography> */}
                  {user?.result?.userType !== "dealer" && (
                    <Button
                      color="primary"
                      size="small"
                      style={{
                        textTransform: "none",
                        backgroundColor: "#ef7f1a",
                        color: "white",
                      }}
                      onClick={() => setClient(null)}
                    >
                      Change
                    </Button>
                  )}
                </>
              )}
              <div style={client ? { display: "none" } : { display: "block" }}>
                <Autocomplete
                  {...clientsProps}
                  PaperComponent={CustomPaper}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="client"
                      label="Select Party"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  value={clients?.name}
                  onChange={(event, value) => {
                    // Ensure the client object includes the _id field
                    if (value && value._id) {
                      setClient({
                        ...value,
                        _id: value._id
                      });
                    } else {
                      setClient(value);
                    }
                    handleClient(value);
                  }}
                  Custom filter function for matching client names with words in different orders
                  filterOptions={(options, { inputValue }) =>
                    options.filter((option) =>
                      matchAllWordsInAnyOrder(
                        inputValue.toLowerCase(),
                        option.name.toLowerCase()
                      )
                    )
                  }
                />
              </div>
              {!client && user?.result?.userType === "admin" && (
                <>
                  <Grid item style={{ paddingBottom: "10px" }}>
                    <Chip
                      avatar={
                        <Avatar
                          style={{ backgroundColor: "#ef7f1a", color: "white" }}
                        >
                          +
                        </Avatar>
                      }
                      label="New Party"
                      onClick={() => setOpen(true)}
                      variant="outlined"
                    />
                  </Grid>
                </>
              )}
            </Container>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            style={{ textAlign: "right", marginBottom: "10px" }}
          >
            {/* <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Status
              </Typography>
              <Typography
                variant="h6"
                gutterBottom
                style={{ color: type === "Receipt" ? "green" : "red" }}
              >
                {type === "Receipt" ? "Paid" : "Unpaid"}
              </Typography> */}
            <Typography
              variant="overline"
              style={{ color: "gray" }}
              gutterBottom
            >
              Date
            </Typography>
            <Typography variant="body2" gutterBottom>
              {invoice
                ? moment(invoice.createdAt).format("MMM Do YYYY")
                : moment().format("MMM Do YYYY")}
            </Typography>
            <Typography
              variant="overline"
              style={{ color: "gray" }}
              gutterBottom
            >
              Payment Term
            </Typography>
            <Typography variant="body2" gutterBottom>
              {/* {selectedDate
                  ? moment(selectedDate).format("MMM Do YYYY")
                  : "27th Sep 2021"} */}
              {client ? client.dueDate + " days" : ""}
            </Typography>
            {/* <Typography variant="overline" gutterBottom>
              Amount
            </Typography>
            <Typography variant="h6" gutterBottom>
              {currency} {toCommas(total)}
            </Typography> */}
          </Grid>
        </Grid>

        <div>
          <TableContainer component={Paper} className="tb-container">
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Item</TableCell>
                  <TableCell>Weight</TableCell>
                  <TableCell>Qty</TableCell>
                  <TableCell>MRP</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceData.items.map((itemField, index) => (
                  // console.log("itemField:", itemField), // Log the itemField object
                  // console.log("itemName:", itemField.itemName), // Log the itemName value
                  <TableRow key={index}>
                    <TableCell
                      align="left"
                      style={{ width: "150px", cursor: "context-menu" }}
                    >
                      {invoiceData.items[index].itemName}
                      <div
                        style={
                          invoiceData.items[index].itemName
                            ? { display: "none" }
                            : { display: "block" }
                        }
                      >
                        <FormControl variant="outlined" fullWidth>
                          <Autocomplete
                            options={items}
                            getOptionLabel={(item) =>
                              `${item.itemName} | ${item.weight}`
                            }
                            value={items.itemName}
                            onChange={(e, value) => {
                              handleNameChange(index, value || "");
                            }} 
                            // Custom filter function for matching client names with words in different orders
                           
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name={`item-${index}`}
                                variant="outlined"
                                placeholder="Search Item"
                                fullWidth
                              />
                            )}
                            filterOptions={(options, { inputValue }) =>
                            options.filter((option) =>
                            matchAllItemWordsInAnyOrder(
                                inputValue.toLowerCase(),
                                option.itemName.toLowerCase(),
                                (option.weight || '').toLowerCase(), 
                              )
                            )
                          }
                          />
                          {/* <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => handleNameChange(index)}
                            >
                              Change
                            </Button> */}
                        </FormControl>
                      </div>
                    </TableCell>

                    <TableCell align="right" style={{ cursor: "context-menu" }}>
                      {itemField.itemName ? (
                        <span>
                          {/* {getItemPrice(invoiceData.items[index].itemName)} */}
                          {itemField.weight}
                        </span>
                      ) : (
                        0
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1, width: "10px" }}
                        type="number"
                        name="quantity"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.quantity}
                        placeholder="0"
                      />{" "}
                    </TableCell>
                    <TableCell align="right" style={{ cursor: "context-menu" }}>
                      {itemField.itemName ? (
                        <span>
                          {/* {getItemPrice(invoiceData.items[index].itemName)} */}
                          {itemField.unitPrice}
                        </span>
                      ) : (
                        0
                      )}
                    </TableCell>

                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="amount"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.quantity * itemField.unitPrice}
                        disabled
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton onClick={() => handleRemoveField(index)}>
                        <DeleteOutlineRoundedIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className={styles.addButton}>
            <button
              onClick={handleAddField}
              style={{ backgroundColor: "#ef7f1a", color: "white" }}
            >
              +
            </button>
          </div>
        </div>
        <div>
          <Grid
            item
            xs={12}
            md={6}
            style={{ paddingRight: "10px", marginTop: "10px" }}
          >
            <Container>
              <Typography
                variant="overline"
                style={{ color: "gray", paddingRight: "3px" }}
                gutterBottom
              >
                Supply From
              </Typography>

              {supplier && (
                <>
                  <Typography variant="subtitle2" gutterBottom>
                    {supplier.name}
                  </Typography>

                  {/* <Typography variant="body2">{supplier.email}</Typography> */}
                  <Typography variant="body2">{supplier.phone}</Typography>
                  {/* <Typography variant="body2">{supplier.address}</Typography> */}
                  {/* <Typography variant="body2">{supplier.dueDate}</Typography> */}
                  {/* <Typography variant="body2">
                      {supplier.dueDate} Credit Days
                    </Typography> */}
                  <Button
                    color="primary"
                    size="small"
                    style={{ textTransform: "none" }}
                    onClick={() => setSupplier(null)}
                  >
                    Change
                  </Button>
                </>
              )}
              <div
                style={supplier ? { display: "none" } : { display: "block" }}
              >
                <Autocomplete
                  {...suppliersProps}
                  PaperComponent={CustomPaper}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="supplier"
                      label="Select Supplier"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  value={suppliers.name}
                  onChange={(event, value) => {
                    // console.log(value);
                    setSupplier(value);
                    // handleSupplier(value);
                  }}
                  // onChange={(event, value) => setSupplier(value) }
                />
              </div>
              {!supplier && user?.result?.userType === "admin" && (
                <>
                  <Grid item style={{ paddingBottom: "10px" }}>
                    <Chip
                      avatar={
                        <Avatar
                          style={{ backgroundColor: "#ef7f1a", color: "white" }}
                        >
                          +
                        </Avatar>
                      }
                      label="New Supplier"
                      onClick={() => setOpenSupplier(true)}
                      variant="outlined"
                    />
                  </Grid>
                </>
              )}
            </Container>
          </Grid>
          <div className={styles.invoiceSummary}>
            {/* <div className={styles.summary}>Order Summary</div>
            <div className={styles.summaryItem}>
              <p>Total Items:</p>
              <h4>{invoiceData.items.length}</h4>
            </div> */}

            <div className={styles.summaryItem}>
              <p>Total [MRP Value]</p>
              <h4
                style={{ color: "black", fontSize: "18px", lineHeight: "8px" }}
              >
                {currency} {toCommas(total)}
              </h4>
            </div>
          </div>
        </div>
        {/* <div className={styles.toolBar}>
          <Container>
            <Grid container>
              <Grid item style={{ marginTop: "16px", marginRight: 40 }}>
                <TextField
                  type="text"
                  step="any"
                  name="rates"
                  id="rates"
                  value={rates}
                  onChange={handleRates}
                  placeholder="e.g 10"
                  label="Discount(%)"
                />
              </Grid> */}
        {/* <Grid item style={{ marginRight: 10, marginLeft: 80 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Due date"
                    format="MM/dd/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid> */}
        {/* <Grid item style={{ width: 270, marginRight: 10 }}>
                <Autocomplete
                  {...defaultProps}
                  id="debug"
                  debug
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select currency"
                      margin="normal"
                    />
                  )}
                  value={currency.value}
                  onChange={(event, value) => setCurrency(value.value)}
                />
              </Grid> */}
        {/* </Grid>
          </Container>
        </div> */}
        <br />
        {signatureDataUrl ? (
          <div>
            <img
              src={signatureDataUrl}
              alt="signature"
              className="signature"
              width={150}
              height={150}
            />

            <Button
              color="primary"
              size="small"
              style={{
                textTransform: "none",
                backgroundColor: "#ef7f1a",
                color: "white",
                margin: 5,
              }}
              onClick={() => setSignatureDataUrl(null)}
            >
              Change
            </Button>
          </div>
        ) : (
          <div>
            <SignaturePad setSignatureDataUrl={setSignatureDataUrl} />
            {}
          </div>
        )}

        <div className={styles.note}>
          <h4>Notes/Payment Info</h4>
          <textarea
            style={{ border: "solid 1px #d6d6d6", padding: "10px" }}
            placeholder="Provide additional details or terms of service"
            onChange={(e) => {
              // console.log("Invoice.js me  signature console.log",signatureDataUrl)
              setInvoiceData({ ...invoiceData, notes: e.target.value });
            }}
            value={invoiceData.notes}
          />
        </div>

        {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
        <Grid container justifyContent="center">
          <Button
            variant="contained"
            style={{
              justifyContentContent: "center",
              backgroundColor: "#ef7f1a",
              color: "white",
            }}
            type="submit"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<SaveIcon />}
          >
            Save and Continue
          </Button>
          {error && (
            <Grid
              container
              justifyContent="center"
              style={{ marginTop: "10px" }}
            >
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            </Grid>
          )}
        </Grid>
      </form>
    </div>
  );
};

export default Invoice;
